<template>
    <div class="footer-bar footer-message-bar">
        <div class="footer-button-wrapper">
            <button @click="goToChat">
                <svg-item :size="24" :icon="'chat'" :color="unreadedMessagesCount > 0 ? 'red' : '--main-color'"></svg-item>
                <span v-show="unreadedMessagesCount > 0" class="unread-counter">
                    {{ unreadedMessagesCount }}
                </span>
            </button>
        </div>
        <div class="footer-button-wrapper">
            <button class="record-button"  :class="{ 'isRecording': isRecording }" v-on:touchstart="onStartRecord" v-on:touchend="onStopRecord" v-on:touchcancel="onStopRecord">
                <svg-item :size="26" :icon="'microfono'" :color="!isRecording ? '--main-color' : '#FFF'"></svg-item>
            </button>
        </div>
        <div class="footer-button-wrapper">
            <audio-buttons
                :use-unread-queue="useUnreadQueuePlayback"
                :can-play-unread="canPlayUnreadMessages"
                :unread-playback-active="unreadPlaybackActive"
                :audio="singleAudioForControls"
            ></audio-buttons>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import cordovaToast from '../../cordova/toast';
import audioButtons from '../elements/AudioButtons';

export default {
    name: 'messagePanel',
    props: [

    ],
    data () {
        return {
            isRecording: false
        };
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
            currentTrip: 'auth/currentTrip',
            unreadedMessagesCount: 'messages/unreadedMessagesCount',
            canPlayUnreadMessages: 'messages/canPlayUnreadMessages',
            unreadPlaybackActive: 'messages/unreadPlaybackActive'
        }),
        useUnreadQueuePlayback () {
            return this.canPlayUnreadMessages;
        },
        singleAudioForControls () {
            return null;
        }
    },

    mounted () {
        this.syncCurrentConversation();
    },
    beforeDestroy () {
        this.stopUnreadPlayback();
    },
    watch: {
        'currentTrip.id' () {
            this.syncCurrentConversation();
        }
    },
    methods: {
        ...mapActions({
            startRecord: 'messages/startRecord',
            stopRecord: 'messages/stopRecord',
            cancelRecord: 'messages/cancelRecord',
            stopUnreadPlayback: 'messages/stopUnreadPlayback'
        }),

        syncCurrentConversation () {
            if (this.currentTrip && this.currentTrip.id != null) {
                this.$store.commit('messages/SET_CURRENT_CONVERSATION', this.currentTrip.id);
            }
        },

        goToChat () {
            this.$router.push({ name: 'chat' });
        },

        onStartRecord () {
            this.isRecording = true;
            this.startRecord({ viajeId: this.currentTrip.id });
        },

        onStopRecord () {
            this.isRecording = false;
            this.stopRecord({ viajeId: this.currentTrip.id }).then(() => {
                cordovaToast.toast(this.translate('audioEnviadoExito')); // 'Audio enviado con exito'
            });
        },

        onCancelRecord () {
            this.isRecording = false;
            this.cancelRecord();
        }
    },
    components: {
        'audio-buttons': audioButtons
    }
};
</script>

<style scoped>
.footer-message-bar {
    box-sizing: border-box;
    height: var(--message-panel-layout-height);
    padding-bottom: var(--safe-area-inset-bottom);
    border-top: 2px solid var(--main-color);
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2200;
    background-color: var(--form-background);
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.footer-button-wrapper {
    display: inline-block;
    width: 32%;
    text-align: center;
}
.footer-button-wrapper button {
    background: transparent;
    border: 0;
    padding: 2px 6px;
}
.footer-button-wrapper .record-button {
    border: 1px solid var(--main-color);
    border-radius: 100%;
    padding: 4px;
    margin-top: 0;
    background: #EEE;
}
.footer-button-wrapper .record-button.isRecording {
    border: 1px solid var(--alert-color);
    background: var(--alert-color);
}
.unread-counter {
    color: var(--main-alert-color);
    font-weight: bold;
    font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/MessagePanel.vue